import React, { useContext, useEffect, useState } from "react";
import { ACCESS_LEVEL } from "consts";
import { guessLocation } from "utils";
import { getUserConfiguration, createUserConfiguration, getProjects } from "api";
//
import { Grid, Tooltip, Button } from "@material-ui/core";
import { SettingsBackupRestore as SettingsBackupRestoreIcon } from "@material-ui/icons";
//
import { UserContext, TemplateContext } from "App";
import { ProjectAutoSuggest, TaskAutoSuggest } from "containers/components/autoSuggest";
import DayFilter from "containers/components/dayFilter/DayFilter";
import UserInfo from "containers/components/misc/UserInfo";
//

export default function UserSettings(props) {
    const userContext = useContext(UserContext);
    const [userConfig, setUserConfig] = useState({ project: null, task: null, workingDays: null });
    const user = props.user;
    const [loading, setLoading] = useState(false);
    const [userLocation, setUserLocation] = useState();
    const { sendReloadChange } = useContext(TemplateContext);

    useEffect(() => {
        setLoading(true);
        getUserLocation();
        getUserConfiguration(true)
            .then((res) => {
                setUserConfig({
                    project: res.project,
                    task: res.task,
                    workingDays: res.workingDays,
                });
                setLoading(false);
            })
            .catch(() => {
                setUserConfig({ project: null, task: null, workingDays: null });
                setLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function fetchProjects(q, pageSize, background) {
        return getProjects(
            q,
            userContext?.Permissions?.GlobalAdministration ? "" : ACCESS_LEVEL.USER,
            null,
            0,
            pageSize,
            null,
            null,
            background
        ).then((value) => value.content);
    }

    async function getUserLocation() {
        await guessLocation(null, userContext).then((loc) => {
            setUserLocation(loc);
        });
    }

    const handleDaysChange = (value) => {
        setUserConfig({ ...userConfig, workingDays: value });
    };
    const handleSubmit = () => {
        createUserConfiguration({
            projectId: userConfig.project?.Id,
            taskId: userConfig.task?.Id,
            workingDays: userConfig.workingDays,
        });
    };

    return (
        <>
            <h2 className="custom-title">Settings</h2>
            <Grid container spacing={2}>
                <Grid item container xs={12} md={12} spacing={2}>
                    <Grid item xs={12}>
                        <UserInfo user={user} />
                    </Grid>
                </Grid>
                <Grid item container xs={12} md={12} spacing={2}>
                    <Grid item xs={12}>
                        <h3 className="subtitle-lightweight">Set default options</h3>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Tooltip title="Set default project" placement="top">
                            <div>
                                <ProjectAutoSuggest
                                    label="Default project"
                                    value={userConfig.project}
                                    fetchOptions={(q) => fetchProjects(q, 32, true)}
                                    onChange={(project) => {
                                        setUserConfig({
                                            ...userConfig,
                                            project: project,
                                            task: null,
                                        });
                                    }}
                                    disabled={loading}
                                />
                            </div>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Tooltip title="Set default task" placement="top">
                            <div>
                                <TaskAutoSuggest
                                    label="Default task"
                                    project={userConfig.project}
                                    value={userConfig.task}
                                    onChange={(task) => setUserConfig({ ...userConfig, task: task })}
                                    disabled={loading}
                                />
                            </div>
                        </Tooltip>
                    </Grid>
                </Grid>

                {!!userLocation && !!userConfig && (
                    <>
                        <Grid item container>
                            <DayFilter
                                days={
                                    userConfig?.workingDays
                                        ? userConfig.workingDays
                                        : userLocation?.workingDays
                                }
                                onDaysChange={(value) => handleDaysChange(value)}
                            />
                        </Grid>
                        <Grid item container justifyContent="center">
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={() => {
                                    handleDaysChange(null);
                                    getUserLocation();
                                }}
                                startIcon={<SettingsBackupRestoreIcon />}
                            >
                                {" "}
                                reset working days
                            </Button>
                        </Grid>
                    </>
                )}
                <Grid item container xs={12} justifyContent="center" spacing={2}>
                    <Grid item>
                        <Button variant="contained" color="primary" onClick={handleSubmit}>
                            Submit
                        </Button>
                    </Grid>
                </Grid>
                {!!user?.Permissions.GlobalAdministration && (
                    <>
                        <Grid item container xs={12} md={12} spacing={2}>
                            <Grid item xs={12}>
                                <h3 className="subtitle-lightweight">Reload page for all users</h3>
                            </Grid>
                        </Grid>
                        <Grid item container justifyContent="center">
                            <Grid item>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={sendReloadChange}
                                >
                                    Reload application
                                </Button>
                            </Grid>
                        </Grid>
                    </>
                )}
            </Grid>
        </>
    );
}
